/**
 * Bulk camera upload for the SELECTED SITE.
 *
 * The page is shared with the local app; this file supplies what is cloud-specific — the
 * capability name the cloud uses (`cameras.add`, where the node says `cameras.create`) and the
 * site's name, so it is never ambiguous which site four hundred cameras are about to land in.
 */
import { CameraImportPage as SharedCameraImportPage, Callout } from '@trinetra/shared';
import { useNode } from '../contexts/NodeContext';

export default function CameraImportPage() {
  const { selectedNode, selectedNodeId } = useNode();

  if (!selectedNodeId) {
    return (
      <div className="space-y-5">
        <h1 className="text-xl font-semibold text-foreground">Bulk camera upload</h1>
        <Callout tone="info">
          Cameras are imported into one site. Pick a site in the switcher above, then upload the
          list here.
        </Callout>
      </div>
    );
  }

  return (
    <SharedCameraImportPage
      permission="cameras.add"
      camerasPath="/cameras"
      siteName={selectedNode?.name}
    />
  );
}
